import { useCallback, useContext, useEffect, useRef, useState } from "react";
import ImageLoader from "../../../../components/ImageLoader";
import { isMobileDevice } from "../../../../utils/getPlatformInfo";
import shareIcon from "../../../../assets/images/share.png";
import shareLight from "../../../../assets/images/shareLight.png";

import styles from "./index.module.scss";
import { useTheme } from "../../../../contexts/ThemeContext/ThemeContext";
import { WEBINAR_Registeration_Status } from "../../../WebinarDetails";
import LoaderImg from "../../../../assets/images/Loader.gif";
import AddToCalendar from "../../../../components/AddToCalendar";
import InviteModal from "../../../../components/InviteModal/InviteModal";
import { getTime } from "../../../../utils/common.utils";
import { INVITEYOURFRIEND_EVENT_BTN } from "../../../../AppConstants/AnalyticsEventName";
import { AnalyticsContext } from "../../../../contexts/Analytics/AnalyticsContextProvider";
import { UserContext } from "../../../../contexts/UserContext/UserContextProvider";
import {
  BannerType,
  ContentType,
  ContentType2,
  Webinar_status,
} from "../../../../AppConstants/TypeConstants";
import BannerLottie from "./BannerLottie/BannerLottie";
import MuxVideo from "@mux/mux-video-react";
import { THEME } from "../../../../AppConstants/ThemeConstant";
import { MuxVideoPlayer } from "../../../../components";
import VideoManager from "../../../../Managers/Video";
import { MediaMetadataContext } from "../../../../contexts/MediaMetaDataContext/MediaMetadataContextProvider";
import ChaptersManager from "../../../../Managers/Video/Chapters";
import SlotsModal from "../SlotsModal";
import {
  VIDEO_COLLECTION,
  WEBINAR_COLLECTION,
} from "../../../../AppConstants/CollectionConstants";
import PrivateVideoVerificationModal from "../../../../components/PrivateContentSection/PrivateVideoVerificationModal";
import { globalsAPI } from "../../../../apis/globalsAPI";

const initialVerificationModal = {
  data: null,
  open: false,
};
function WebinarHeadCard({
  eventDetails,
  handleBookyourSpotBtn,
  registerationStatus,
  isEventLive,
  setSpeedControlOpen,
}) {
  const { isDark } = useTheme();
  const muxVideoRef = useRef("");
  const [showInviteModal, setShowInviteModal] = useState(false);
  const { addGAWithUserInfo } = useContext(AnalyticsContext);
  const { mediaMetadata, updateMediaMetadata } =
    useContext(MediaMetadataContext);
  const { user } = useContext(UserContext);
  const [isvideoLoading, setIsVideoLoading] = useState(true);
  const [durationObj, setDurationObj] = useState({});
  const [endedVideoData, setEndedVideoData] = useState(null);
  const [allChapters, setAllChapters] = useState(null);
  const [openSlotsModal, setOpenSlotsModal] = useState(false);
  const [verificationModal, setVerificationModal] = useState(
    initialVerificationModal
  );

  useEffect(() => {
    if (showInviteModal) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
  }, [showInviteModal]);

  useEffect(() => {
    if (eventDetails) {
      const interval = setInterval(() => {
        setDurationObj(
          getTime(eventDetails.startTime.seconds * 1000, interval)
        );
      }, 1000);

      // get webinar ended video
      if (!endedVideoData) {
        getVideoData(eventDetails);
      }

      return () => clearInterval(interval);
    }
  }, [eventDetails]);

  const getVideoData = async (eventDetails) => {
    const { show, videoID } = eventDetails.archieveVideo || {};

    if (show && videoID) {
      if (user) {
        let video = await VideoManager._get.getVideoById(videoID);
        if (video) {
          setEndedVideoData(video);
          fetchAllChapters(video.id);
        }
      } else {
        try {
          const res = await globalsAPI.generateTempVideoToken({
            type: VIDEO_COLLECTION,
            id: videoID,
          });
          let video = res.data;
          if (video) {
            setEndedVideoData(video);
            fetchAllChapters(video.id);
          }
        } catch (error) {
          console.error(error);
        }
      }
    }
  };

  const fetchAllChapters = async (videoId) => {
    let chapters = await ChaptersManager._get.getAllChapters(videoId);

    if (chapters) {
      setAllChapters(chapters.content);
    }
  };

  const handleInviteBtn = () => {
    addClickAnalytics(INVITEYOURFRIEND_EVENT_BTN);
    setShowInviteModal(true);
  };

  const addClickAnalytics = (eventName) => {
    addGAWithUserInfo(eventName, { eventId: eventDetails.id, ...eventDetails });
  };

  const handleInviteBtnClose = () => {
    setShowInviteModal(false);
  };

  const closeStartWatchingBtn = (videoDur, videoWatched, type) => {
    if (videoDur && endedVideoData) {
      updateMediaMetadata(
        endedVideoData.id,
        videoWatched,
        videoDur,
        ContentType.VIDEO
      );
    }
  };
  const handleVideoLoading = (bool) => {
    setIsVideoLoading(bool);
  };

  const handleOpenSlotsModal = useCallback(() => {
    setOpenSlotsModal(true);
  }, []);

  const handleCloseSlotsModal = useCallback(() => {
    setOpenSlotsModal(false);
  }, []);
  const handleClosePrivateModal = useCallback(() => {
    setVerificationModal(initialVerificationModal);
  }, []);

  const handleOpenPrivateModal = useCallback((item) => {
    setVerificationModal({ open: true, data: item });
  }, []);

  const handleBookyourSpotBtnAfterDetails = (cb = () => {}, data = null) => {
    cb(true);
    handleBookyourSpotBtn(eventDetails.id, null, data);
  };

  return (
    eventDetails && (
      <>
        {eventDetails.archieveVideo &&
        eventDetails.archieveVideo.show &&
        eventDetails.status === Webinar_status.ENDED ? (
          <div className={`${styles.headCard} ${styles.videoContainer}`}>
            {isvideoLoading && (
              <div className={styles.placeholderWrapper}>
                <div className={styles.loader}>
                  <img src={LoaderImg} alt="loading..." />
                </div>
                <img
                  height={"100%"}
                  width={"100%"}
                  src={eventDetails.thumbnailUrl}
                  alt={"videoPlaceholder"}
                />
              </div>
            )}
            <div className={styles.videoPlayer}>
              {endedVideoData && (
                <MuxVideoPlayer
                  speedControlToggleCB={setSpeedControlOpen}
                  showPlayer={true}
                  isSidePanelOpen={false}
                  closeStartWatchingBtn={closeStartWatchingBtn}
                  videoData={{
                    ...endedVideoData,
                    targetType: ContentType2["Standalone Video"],
                  }}
                  muxVideoRef={muxVideoRef}
                  themeType={THEME.EVENT_ENDED_THEME}
                  handleVideoLoading={handleVideoLoading}
                  startingPoint={
                    mediaMetadata[endedVideoData.id]
                      ? mediaMetadata[endedVideoData.id].lastWatchTimestamp
                      : 0
                  }
                  allChapters={allChapters}
                />
              )}
            </div>
          </div>
        ) : (
          <div className={styles.headCard}>
            <div className={styles.mainHead}>
              {eventDetails.eventBannerType ? (
                eventDetails.eventBannerType === BannerType.JSON ? (
                  <BannerLottie eventDetails={eventDetails} />
                ) : eventDetails.eventBannerType === BannerType.VIDEO ? (
                  <MuxVideo
                    playbackId={
                      isMobileDevice
                        ? eventDetails.videos?.mobile?.playbackid
                        : eventDetails.videos?.desktop?.playbackid
                    }
                    slot="media"
                    preload="auto"
                    crossOrigin="true"
                    playsInline={true}
                    preferMse
                    type="hls"
                    className={styles.thumbImg}
                    muted={true}
                    autoPlay
                    loop={true}
                  />
                ) : (
                  <>
                    <ImageLoader
                      src={
                        isMobileDevice
                          ? eventDetails.thumbnailUrl
                          : eventDetails.desktopThumbnailUrl
                      }
                      alt="eventImg"
                      imageHeight={isMobileDevice ? 375 : 505}
                      imageWidth={isMobileDevice ? "100vw" : "80vw"}
                      className={styles.thumbImg}
                    />
                    {/* {eventDetails && (
                <div className={styles.data}>
                  <div className={styles.title}>{eventDetails.title}</div>
                  <div className={styles.eventTime}>
                    {new Date(
                      eventDetails.startTime.seconds * 1000
                    ).toUTCString()}{" "}
                    -
                    {new Date(
                      eventDetails.endTime.seconds * 1000
                    ).toUTCString()}
                  </div>
                </div>
              )} */}
                  </>
                )
              ) : null}
            </div>
            <div
              className={`${styles.timerCard} ${
                eventDetails.status === Webinar_status.ENDED &&
                styles.timerCard2
              } ${
                eventDetails.eventBannerType &&
                eventDetails.eventBannerType !== BannerType.JSON &&
                styles.timerCard3
              }`}
              // style={{
              //   background: isDark
              //     ? "rgba(0, 0, 0, 0.4)"
              //     : "rgba(255, 255, 255, 0.4)",
              // }}
            >
              {Object.keys(durationObj).length !== 0 ? (
                <div className={styles.timerPart}>
                  {durationObj.seconds <= 0 || isNaN(durationObj.seconds) ? (
                    <div>
                      {isEventLive ? (
                        <div className={`live-text ${styles.eventLive}`}>
                          <span className="liveDot"></span> Live
                        </div>
                      ) : eventDetails.status === Webinar_status.ENDED ? (
                        <div className={styles.live}>
                          Event has ended.
                          <br />
                          Thank you for joining.
                        </div>
                      ) : (
                        <div className={styles.live}>Event Will Start Soon</div>
                      )}
                    </div>
                  ) : (
                    <div>
                      Event Starts in :
                      <div className={styles.timer}>
                        <div className={styles.timeValue}>
                          {durationObj.d || 0}
                          <div className={styles.smallInfo}>days</div>
                        </div>
                        <div className={styles.timeValue}>
                          {durationObj.h || 0}
                          <div className={styles.smallInfo}>hours</div>
                        </div>
                        <div className={styles.timeValue}>
                          {durationObj.m || 0}
                          <div className={styles.smallInfo}>minutes</div>
                        </div>
                        <div className={styles.timeValue}>
                          {durationObj.s || 0}
                          <div className={styles.smallInfo}>seconds</div>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              ) : (
                <div className={styles.timerPart}></div>
              )}

              {eventDetails.status !== Webinar_status.ENDED && (
                <div className={styles.attendiesPart}>
                  Attendees
                  <div className={styles.count}>
                    {eventDetails.attendenceCount}
                  </div>
                  <div className={styles.smallInfo}>and counting</div>
                </div>
              )}
              {eventDetails.status !== Webinar_status.ENDED && (
                <div
                  className={styles.actionBtns}
                  style={{ marginLeft: isMobileDevice && user && "4rem" }}
                >
                  {registerationStatus ===
                    WEBINAR_Registeration_Status.notRegistered && (
                    <div
                      className={styles.bookPart}
                      onClick={() => {
                        if (
                          eventDetails.needPrerequisite &&
                          eventDetails.prerequisite
                        ) {
                          let obj = {
                            isUnlockedForUser: false,
                            prerequisite: true,
                            courseData: eventDetails,
                          };
                          handleOpenPrivateModal(obj);
                        } else if (
                          eventDetails.slots &&
                          eventDetails.slots.enable
                        ) {
                          handleOpenSlotsModal();
                        } else {
                          handleBookyourSpotBtn(eventDetails.id);
                        }
                      }}
                    >
                      <button className={`btn ${styles.bookBtn}`}>
                        {isEventLive ? "Enter Event" : "Book Your Spot"}
                      </button>
                    </div>
                  )}
                  {registerationStatus ===
                    WEBINAR_Registeration_Status.Registered && (
                    <AddToCalendar eventDetails={eventDetails} />
                  )}
                  {registerationStatus ===
                    WEBINAR_Registeration_Status.checking && (
                    <div className={styles.bookPart}>
                      <button className={`btn ${styles.bookBtn}`}>
                        <img src={LoaderImg} alt="" height="100%" />
                      </button>
                    </div>
                  )}
                  {user && (
                    <div onClick={handleInviteBtn} className={styles.sharePart}>
                      {/* <img src={isDark ? shareIcon : shareLight} alt="share" /> */}
                      <img src={shareIcon} alt="share" />
                      <span>Share</span>
                    </div>
                  )}
                </div>
              )}
            </div>
            {showInviteModal && (
              <div
                style={{
                  zIndex: "50",
                  marginBottom: `${isMobileDevice ? "-90%" : "-27%"}`,
                }}
              >
                <InviteModal
                  from={ContentType2.Webinar}
                  type="event"
                  details={eventDetails}
                  handleClose={handleInviteBtnClose}
                  customClass={"inviteModal"}
                />
              </div>
            )}

            <SlotsModal
              isVisible={openSlotsModal}
              onClose={handleCloseSlotsModal}
              handleBookyourSpotBtn={handleBookyourSpotBtn}
              eventDetails={eventDetails}
            />
            {verificationModal.open && (
              <PrivateVideoVerificationModal
                collection={WEBINAR_COLLECTION}
                verificationModal={verificationModal}
                handleClose={handleClosePrivateModal}
                handleVerifyButton={handleClosePrivateModal}
                creteUserDoc={handleBookyourSpotBtnAfterDetails}
                showBackgroundBlur={true}
              />
            )}
          </div>
        )}
      </>
    )
  );
}

export default WebinarHeadCard;
